export default __webpack_public_path__ + "content/media/25.bc26ecce.jpg";